import AOS from 'aos'
import 'aos/dist/aos.css'
import { nextTick } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) return

  const initAOS = () => {
    // Unified AOS initialization with desired defaults
    AOS.init({
      duration: 800,
      easing: 'ease',
      delay: 200,
      offset: 200,
      once: false,
      mirror: true,
      anchorPlacement: 'top-bottom',
    })
  }

  // Debounce utility (local, minimal)
  const debounce = (fn: () => void, wait = 150) => {
    let t: any
    return () => {
      clearTimeout(t)
      t = setTimeout(fn, wait)
    }
  }

  // Initialize once app is mounted in client
  nuxtApp.hook('app:mounted', async () => {
    initAOS()
    // Ensure any late-mounted nodes are measured
    await nextTick()
    AOS.refreshHard()

    // One more pass after layout-heavy libs (e.g., Swiper) finish
    requestAnimationFrame(() => {
      setTimeout(() => {
        AOS.refreshHard()
      }, 200)
    })
  })

  // Refresh after every route change to apply to newly rendered nodes
  if (nuxtApp.$router) {
    nuxtApp.$router.afterEach(async () => {
      await nextTick()
      AOS.refreshHard()
    })
  }

  // Also listen to Nuxt page finish hook (covers transitions)
  nuxtApp.hook('page:finish', async () => {
    await nextTick()
    AOS.refreshHard()
  })

  // Refresh when the full window has loaded (images/fonts settled)
  window.addEventListener('load', () => {
    AOS.refreshHard()
  })

  // Refresh on resize (debounced) as offsets can change with viewport
  const debouncedRefresh = debounce(() => AOS.refreshHard(), 150)
  window.addEventListener('resize', debouncedRefresh)
})
